<template>
	<div class="home">
		<div class="swiper-box">
			<swiper class="swiper" :options="swiperOption">
				<!-- 第一页 -->
				<swiper-slide class="topvideo-slide">
					<video style="object-fit:fill;object-position: center;height:100%" autoplay muted loop>
							<source src="https://voge-resource.vogemotor.com/1654853d65b58733087.mp4" type="video/mp4"/>
					</video>
					<!-- <img class="shubiaoImg" src="../../assets/shubiao.png" alt=""> -->
					<img src="../../assets/xia.png" class="nextImg" alt="">
				</swiper-slide>
				<!-- 第二页 -->
				<swiper-slide class="car-show-slide">
					<div class="title" :class="changeIndex == '1' ? 'animate__animated animate__fadeInUp' : ''">
						<div class="huangheng"></div>
						<div class="top-title">车型展示</div>
						<div class="top-entitle">Model Display</div>
					</div>
					<el-tabs v-model="activeName" @tab-click="handleClick" class="tabs-box" :class="changeIndex == '1' ? 'animate__animated animate__fadeInUp' : ''">
						<el-tab-pane v-for="(item,idx) in tabslist" :key="idx" :label="item.class_name" :name="item.class_id">
							<div v-if="item.class_list.length>0">
								<swiper class="tab-pane-swiper" :options="carShowSwiperOption" :class="changeIndex == '1' ? 'animate__animated animate__fadeInUp' : ''">
									<swiper-slide v-for="(item1,idx1) in item.class_list" :key="idx1">
										<div class="car-content" @click="toMotorbikeDetails(3,item1.lead_product_id)">
											<div class="content-img">
												<img :src="item1.top_drop_down_img" alt="">
											</div>
											<div class="swiperText">{{item1.pro_name}}</div>
											<div class="nextts">探索详情</div>
										</div>
									</swiper-slide>
									<div class="nextBtn" slot="button-next"><img src="../../assets/nextBtn.png" alt=""></div>
									<div class="prevBtn" slot="button-prev"><img src="../../assets/prevBtn.png" alt=""></div>
								</swiper>
								<div class="leftBgm"></div>
								<div class="rightBgm"></div>
							</div>

							<el-empty v-else description="暂无数据" style="height:555px;"></el-empty>
						</el-tab-pane>
					</el-tabs>
				</swiper-slide>
				<!-- 第三页 -->
				<swiper-slide>
					<div class="originality " :class="changeIndex == '2' ? 'animate__animated animate__fadeInUp ' : ''">
							<div class="originality-title" :class="changeIndex == '2' ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''">
								<img src="../../assets/jxwj.png" alt="">
								<index-title title="匠心无极" titleTow="焕新启程 创想未来" topath="/originality-story" :actNum="2"></index-title>
							</div>
					</div>
				</swiper-slide>
				<!-- 第四页 -->
				<swiper-slide class="topvideo-slide">
					<div class="taste">
							<div class="taste-title" :class="changeIndex == '3' ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''">
								<img src="../../assets/yytj.png" alt="">
								<index-title title="预约品鉴" titleTow="感受无极大排量摩托的卓越品质" topath="/test-drives" :actNum="6"></index-title>
							</div>
							<video style="object-fit:fill;object-position: center;height:100%" autoplay muted loop :class="changeIndex == '3' ? 'animate__animated animate__fadeInUp ' : ''">
								<source src="https://voge-resource.vogemotor.com/media/video_sy.mp4" type="video/mp4" />
							</video>
					</div>
				</swiper-slide>
				<!-- 第五页 -->
				<swiper-slide class="topvideo-slide">
					<div class="serve" :class="changeIndex == '4' ? 'animate__animated animate__fadeInUp' : ''">
						<div class="serve-title" :class="changeIndex == '4' ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''">
							<img src="../../assets/fwzc.png" alt="">
							<index-title  title="服务支持" titleTow="换新启程 创想未来" topath="/warranty-coverage" :actNum="5" :class="changeIndex == '4' ? 'animate__animated animate__fadeInUp ' : ''"></index-title>
						</div>
					</div>
				</swiper-slide>
				<!-- 底部 -->
				<swiper-slide>
					<base-footer></base-footer>
				</swiper-slide>
				<!-- <div class="swiper-pagination" slot="pagination"></div> -->
			</swiper>
		</div>
	</div>
</template>
<script>
import bus from "@/utils/bus";
import IndexTitle from '../../components/indextitle'
import BaseFooter from "@/components/BaseFooter.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getProductsDropDownApi } from "../../../request/api.js";
export default {
		metaInfo: {
			title: 'VOGE无极机车-摩托车品牌官网', // set a title
			meta: [{                 // set meta
					name: '无极摩托|隆鑫摩托|VOGE摩托|摩托车品牌|越野摩托车|无极机车|无极官网|VOGE机车|无极300',
					content: '隆鑫通用动力股份有限公司旗下的无极机车，又名VOGE机车，是一家集研发、生产、销售、服务为一体的摩托车品牌，VOGE摩托的无极300系列包含越野摩托车、街道摩托车等类型，能满足不同用户的需求。',
					keywords:'无极摩托|隆鑫摩托|VOGE摩托|摩托车品牌|越野摩托车|无极机车|无极官网|VOGE机车|无极300'
			}]
		},
    name:'home',
		components:{
			swiper,swiperSlide,IndexTitle,BaseFooter
		},
		data(){
			const that = this
			return{
				activeName:'8',
				changeIndex:0,
				swiperOption: {
					autoHeight:true,
          direction: 'vertical',
					slidesPerView: "auto", // 记得这里写 auto 不要默认写1哦
	        observer: true, //修改swiper自己或子元素时，自动初始化swiper
	        observeParents: true, //修改swiper的父元素时，自动初始化swiper
					mousewheel:true,
					navigation: {
            nextEl: '.nextImg',
          },
					on:{
						transitionStart:function(swiper){
							that.changeIndex = this.activeIndex
						}
					}
        },
				// 第二页swiper
				carShowSwiperOption: {
					slidesPerView: "auto", // 记得这里写 auto 不要默认写1哦
	        observer: true, //修改swiper自己或子元素时，自动初始化swiper
	        observeParents: true, //修改swiper的父元素时，自动初始化swiper
					centeredSlides: true,
          loop: true,
					navigation: {
            nextEl: '.prevBtn',
						prevEl: '.nextBtn'
          }
				},
				tabslist:[],
				motuochelist:[],
			}
		},
		created(){
			this.getProductsDropDownApi()
		},
		methods:{
			// 首页数据获取
			getProductsDropDownApi(){
            const params = {
                m:'Mobile',
                c:'MajorProduct',
                a:'production_class_list',
                lang:1
            }
					getProductsDropDownApi(params).then(({data})=>{
							this.tabslist = data.datas.info
					})
			},
			handleClick(){},
			// 跳转 - 详情
			toMotorbikeDetails(val,params){
				bus.$emit('actNum',val)
				this.$router.push({
					path:"/motorbike-details",
					query:{id:params}
				})
			}
		},
}
</script>
<style lang="scss">
// .home{
	.home{
		// max-width: 1920px;
		width: 100%;
		margin: 0 auto;
	}
	.swiper-box{
		min-width: 1200px;
		.topvideo{
			width: 100%;
		}
		.topvideo-slide,.car-show-slide{
			height: 100vh;
		}
		.topvideo-slide{
			.shubiaoImg{
				position: absolute;
				top: 40vh;
				left: 3vw;
				z-index: 1;
			}
			.nextImg{
				position: absolute;
				left: 50vw;
				bottom: 3vw;
				z-index: 1;
			}
		}
		.car-show-slide{
			background: url('https://voge-resource.vogemotor.com/media/indexTowBgm.jpg') no-repeat !important;
			background-size: cover !important;
			width: 100%;
			height: 100vh;
			.title{
				position: relative;
				top: 14vh;
				left: 6vw;
				.huangheng{
            width: 86px;
            height: 5px;
            background-color: #Facc0a;
        }
        .top-title{
            font-size: 30px;
            margin-top: 16px;
            font-weight: bold;
        }
        .top-entitle{
            font-size: 18px;
            margin-top: 12px;
        }
			}
			.tabs-box{
				position: relative;
				top: 150px; //8%
				.el-tabs__content{
					top: 20px;
					height: auto;
					.swiper-container{
						height: auto;
					}
				}
				.el-tabs__nav-wrap::after{
					background-color: transparent;
				}
				.el-tabs__nav-scroll{
					display: flex;
					justify-content: center;
				}
				.el-tabs__item:hover{
					color: #000000;
					font-weight: 800;
				}
				.el-tabs__nav{
					width: 60vw;
					display: flex;
					justify-content: space-between;
					.el-tabs__active-bar{
						display: none;
					}
					.el-tabs__item{
						padding: 0;
					}
					.is-active{
						color: black;
						font-weight: 800;
						border-bottom: 2px solid black;
					}
				}
				.tab-pane-swiper{
					.swiper-slide{
						width: 60%;
						.car-content{
							display: flex;
							flex-direction: column;
							align-items:center;
							cursor: pointer;
							.content-img{
								width: 800px;
								height: 500px;
								img{
									width: 100%;
									object-fit: cover;
								}
							}
							.swiperText{
								font-size: 40px;
							}
							.nextts{
								margin-top: 10px;
								cursor: pointer;
								display: inline-block;
							}
						}
					}
					.swiper-slide-prev {
						transform: scale(0.3);
						position: relative;
						left: 210px;
						.swiperText,.nextts{
							display: none !important;
						}
					}
					.swiper-slide-next {
						transform: scale(0.3);
						position: relative;
						right: 210px;
						.swiperText,.nextts{
							display: none !important;
						}
					}
				}
				.nextBtn{
					position: absolute;
					left: 150px;
					top: 240px;
					width: 65px;
					height: 65px;
					cursor: pointer;
					z-index: 1;
					img{
						width: 100%;
					}
				}
				.prevBtn{
					position: absolute;
					right: 150px;
					top: 240px;
					width: 65px;
					height: 65px;
					cursor: pointer;
					z-index: 1;
					img{
						width: 100%;
					}
				}
				.leftBgm{
					width: 153px;
					height: 458px;
					background: url('../../assets/tuoyuanyou.png') no-repeat left center;
					background-size: 100% 100%;
					position: absolute;
					left: 0;
					top: 5%;
				}
				.rightBgm{
					width: 153px;
					height: 458px;
					background: url('../../assets/tuoyuanzuo.png') no-repeat right center;
					background-size: 100% 100%;
					position: absolute;
					right: 0;
					top: 5%;
				}
			}
		}
		.originality{
			width: 100vw;
			height: 100vh;
			background: url('https://voge-resource.vogemotor.com/media/jswj.jpg') no-repeat center center !important;
			background-size: cover !important;
			position: relative;
			.originality-title{
				position: absolute;
				right: 228px;
				top: 231px;
			}
		}
		.taste{
			position: relative;
			height: 100%;
			.taste-title{
					position: absolute;
					left: 159px;
					top: 170px;
					z-index: 99;
			}
		}
		.serve{
			width: 100vw;
			height: 100vh;
			background: url('https://voge-resource.vogemotor.com/media/serveBgm.jpg') no-repeat center center !important;
			background-size: cover !important;
			position: relative;
			.serve-title{
				position: absolute;
				right: 228px;
				top: 231px;
			}
		}
	}
	.swiper-slide{
		overflow: hidden;
	}
	.home .swiper-container{
		height: 100vh;
	}
// }
@media screen and (min-width: 1200px) and (max-width: 1500px){
	.car-show-slide .swiper-slide-next{
		right: 162px !important;
	}
	.car-show-slide .swiper-slide-prev{
		left: 162px !important;
	}
}
@media screen and (min-width:1355px) and (max-width:1370px){
	.tabs-box{
		top: -4% !important;
	}
	.swiper-box .car-show-slide .title{
		top: 11vh !important;
	}
	.swiper-box .content-img{
		width: 600px !important;
		height: 375px !important;
	}
	.swiper-box .leftBgm{
		top: 0px !important;
	}
	.swiper-box .rightBgm{
		top: 0px !important;
	}
	.swiper-box .nextBtn{
		top: 210px !important;
	}
	.swiper-box .prevBtn{
		top: 210px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue